import { Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import { getProjectConfig } from '../../../../modules/executions';
import MultiSelect from '../../MultiSelect';
import PlatformSelection from './PlatformSelectionForm';

const ExecutionScopeForm = ({
  values,
  setFieldValue,
  isEditing = true,
  isCycleCompleted,
  isPlatformRequired = true,
}) => {
  const { projectId } = useParams();
  const [loading, setLoading] = useState(false);
  const [projectConfig, setProjectConfig] = useState({});
  const {
    platforms = [],
    subPlatforms = [],
    browsers = [],
    languages = [],
    geographies = [],
    cloudDevice = [],
  } = values;

  useEffect(() => {
    const fetchProjectData = async () => {
      setLoading(true);
      try {
        const response = await getProjectConfig(projectId);
        setProjectConfig(response);
      } catch (error) {
        console.error('Error fetching project config:', error);
      }
      setLoading(false);
    };
    fetchProjectData();
  }, [projectId]);

  const filterSelectedValues = (selectedValues, availableOptions) =>
    selectedValues?.filter((value) => availableOptions?.includes(value));

  const cloudDeviceOptions = [...(projectConfig?.cloud_device || [])];
  if (
    cloudDeviceOptions.includes('Others') &&
    projectConfig?.other_cloud_device
  ) {
    const index = cloudDeviceOptions.indexOf('Others');
    cloudDeviceOptions[index] = projectConfig.other_cloud_device;
  }

  const browserOptions = [...(projectConfig?.browsers || [])];
  if (
    browserOptions.includes('Others') &&
    projectConfig?.other_browsers?.length > 0
  ) {
    const index = browserOptions.indexOf('Others');
    browserOptions.splice(index, 1, ...projectConfig.other_browsers);
  }

  const renderMultiSelect = (options, selectedValues, field, placeholder) => {
    const filteredSelectedValues = filterSelectedValues(
      selectedValues,
      options
    );

    return (
      <Col md={4}>
        <Form.Group controlId={field}>
          <Form.Label>{placeholder}</Form.Label>
          {isEditing && !isCycleCompleted ? (
            <MultiSelect
              options={options}
              selectedValues={filteredSelectedValues}
              onChange={(value) => setFieldValue(field, value)}
              placeholder={`Select ${placeholder.toLowerCase()}`}
            />
          ) : (
            <p className="form-static-text">
              {filteredSelectedValues?.length > 0
                ? filteredSelectedValues.join(', ')
                : 'None'}
            </p>
          )}
        </Form.Group>
      </Col>
    );
  };

  return loading ? (
    <Typography className="text-center text-muted" variant="body2">
      Fetching execution scope...
    </Typography>
  ) : (
    <>
      <Typography variant="h6" className="mb-2">
        Execution Scope
      </Typography>
      <Row>
        <PlatformSelection
          platforms={filterSelectedValues(platforms, projectConfig?.platforms)}
          subPlatforms={filterSelectedValues(
            subPlatforms,
            projectConfig?.sub_platforms
          )}
          browsers={filterSelectedValues(browsers, browserOptions)}
          geographies={filterSelectedValues(geographies, projectConfig?.geographies)}
          isCycleCompleted={isCycleCompleted}
          projectConfig={projectConfig}
          isEditing={isEditing}
          setFieldValue={setFieldValue}
          isPlatformRequired={isPlatformRequired}
          browserOptions={browserOptions}
        />
      </Row>

      <Row>
        {projectConfig?.cloud_device?.length > 0 &&
          renderMultiSelect(
            cloudDeviceOptions,
            cloudDevice,
            'cloudDevice',
            'Cloud Device Labs'
          )}
        {projectConfig?.multiple_languages === 'Yes' &&
          projectConfig?.languages?.length > 0 &&
          renderMultiSelect(
            projectConfig?.languages,
            languages,
            'languages',
            'Languages'
          )}
      </Row>
    </>
  );
};

export default ExecutionScopeForm;
